var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstuctClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66675C5.40001 1.66675 1.66667 5.40008 1.66667 10.0001C1.66667 14.6001 5.40001 18.3334 10 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 10 1.66675ZM10.8333 15.8334H9.16667V14.1667H10.8333V15.8334ZM12.5583 9.37508L11.8083 10.1417C11.2083 10.7501 10.8333 11.2501 10.8333 12.5001H9.16667V12.0834C9.16667 11.1667 9.54167 10.3334 10.1417 9.72508L11.175 8.67508C11.4833 8.37508 11.6667 7.95842 11.6667 7.50008C11.6667 6.58342 10.9167 5.83342 10 5.83342C9.08334 5.83342 8.33334 6.58342 8.33334 7.50008H6.66667C6.66667 5.65841 8.15834 4.16675 10 4.16675C11.8417 4.16675 13.3333 5.65841 13.3333 7.50008C13.3333 8.23342 13.0333 8.90008 12.5583 9.37508Z",
    fill: "#6138F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstuctClose);
export default __webpack_public_path__ + "static/media/instuct_close.813719a417008eeff0e01912aded3d30.svg";
export { ForwardRef as ReactComponent };